
import React from 'react';
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";

interface ShareToggleProps {
  isPublic: boolean;
  setIsPublic: (value: boolean) => void;
  hasPublicShare: boolean;
  hasPrivateShare: boolean;
}

const ShareToggle: React.FC<ShareToggleProps> = ({ 
  isPublic, 
  setIsPublic,
  hasPublicShare,
  hasPrivateShare
}) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <Switch
          id="public-mode"
          checked={isPublic}
          onCheckedChange={setIsPublic}
          disabled={hasPublicShare || hasPrivateShare}
        />
        <Label htmlFor="public-mode">
          {isPublic ? "Public (allows collaborative editing)" : "Private (read-only)"}
        </Label>
      </div>
      <p className="text-sm text-gray-500">
        {hasPublicShare || hasPrivateShare ? (
          `This note already has a ${hasPublicShare ? 'public' : 'private'} share link. Each note can only have one link per mode.`
        ) : (
          isPublic 
            ? "Anyone with the link can edit this note after signing in." 
            : "Anyone with the link can view this note in read-only mode."
        )}
      </p>
    </div>
  );
};

export default ShareToggle;
